import { Grid, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';
import { TextValidator } from 'react-material-ui-form-validator';

// GRID TEXT VALIDATOR
//grid sizes, label, an name (same as the id), type, value, classes, onChange, validators, errorMessages
// assumptions: is required, fullWidth
// EXMAPLE
/* <GridTextValidator
    xs={12}
    sm={6}
    label="Zipcode"
    type="text"
    name="groupZipcode"
    value={this.state.groupZipcode}
    onChange={this.handleChange}
    classes={classes}
    validators={['required']}
    errorMessages={['Zipcode is required']}
/> */
export const GridTextValidator = props => {
    return (
        <Grid item xs={props.xs ? props.xs : null} sm={props.sm ? props.sm : null}
            md={props.md ? props.md : null} lg={props.lg ? props.lg : null} xl={props.xl ? props.xl : null}>
            <TextValidator
                label={props.label}
                type={props.type}
                name={props.name}
                id={props.id || props.name}
                value={props.value}
                className={[props.classes.textField].join(' ')}
                onChange={props.onChange}
                validators={props.validators}
                errorMessages={props.errorMessages}
                fullWidth
                required
            />
        </Grid>)
}

// AUTOCOMPELTE TEXT FIELD
// give it grid sizes (xs,sm,md,lg,xl), an id, options (labels), value, onChange, classes, and a label
// ASSUMPTIONS : options are option.label
// EXAMPLE
/* <GridAutoTextField
    xs={12}
    sm={6}
    lg={4}
    name="categoryID"
    options={this.state.categories}
    value={this.state.categoryID}
    //handleSelectChange={this.handleSelectChange}
    onChange={this.onChange}
    classes={classes}
    label="Category"
/> */

export const GridAutoTextField = props => {
    return (
        <Grid item xs={props.xs ? props.xs : null} sm={props.sm ? props.sm : null}
            md={props.md ? props.md : null} lg={props.lg ? props.lg : null} xl={props.xl ? props.xl : null}>
            <Autocomplete
                name={props.name}
                id={props.id || props.name}
                options={props.options}
                getOptionLabel={props.getOptionLabel ? props.getOptionLabel : (option) => option.label}
                isOptionEqualToValue={(option, val) => option.value === val.value}
                value={props.value}
                disabled={props.disabled}
                // getOptionSelected={props.getOptionSelected}
                // onChange={(event, value) => { props.handleSelectChange(props.id, value) }}
                onChange={(event, value) => {
                    event.target = {
                        ...event.target,
                        name: props.name,
                        value: value
                    }
                    return props.onChange(event, value, props.name)
                }}
                className={props.classes? [props.classes.autoComplete].join(' ') : null}
                autoHighlight
                renderInput={(params) => (
                    <TextField
                        {...params}
                        name={props.name}
                        label={props.label}
                        className={props.classes ? [props.classes.textField].join(' ') : null}
                    />)}
            />
        </Grid>
    );
}

// AUTOCOMPELTE TEXT VALIDATOR
// give it grid sizes (xs,sm,md,lg,xl), an id, if required,validators, errorMessages, options (labels), value, handleChange, classes, and a label
// ASSUMPTIONS : options are option.label
// EXAMPLE
/*<GridAutoTextValidator
    xs={12}
    sm={6}
    name="groupState"
    options={groupStates}
    value={this.state.groupState}
    //handleSelectChange={this.handleSelectChange}
    onChange={this.handleChange}
    classes={classes}
    validators={['required']}
    errorMessages={['State is required']}
    required
    label="State"
/> */
export const GridAutoTextValidator = props => {
    return (
        <Grid item xs={props.xs ? props.xs : null} sm={props.sm ? props.sm : null}
            md={props.md ? props.md : null} lg={props.lg ? props.lg : null} xl={props.xl ? props.xl : null}>
            <AutoTextValidator
                name={props.name}
                id={props.id || props.name}
                options={props.options}
                disabled={props.disabled}
                value={props.value}
                onChange={props.onChange}
                classes={props.classes}
                validators={props.validators}
                errorMessages={props.errorMessages}
                label={props.label}
            />
            {/* <Autocomplete
                name={props.name}
                id={props.id || props.name}
                options={props.options}
                disabled={props.disabled}
                getOptionLabel={(option) => option.label}
                value={props.value}
                onChange={(event, value) => {
                    const defaultEvent = {
                        target: {
                            name: props.name || props.id,
                            value: value
                        }
                    }
                    return props.onChange(defaultEvent)
                }}
                className={[props.classes.autoComplete].join(' ')}
                autoHighlight
                renderInput={(params) => (
                    <TextValidator
                        {...params}
                        name={props.name}
                        required
                        label={props.label}
                        value={props.value} // value must be set for the validators to work
                        errorMessages={props.errorMessages}
                        validators={props.validators}
                        className={[props.classes.textField].join(' ')}
                        fullWidth
                    />)} 
            />*/}
        </Grid>
    )
}

/// requires name,options, if disabled,value,onChange,classes,label,validators,errormessages
/* Example
<AutoTextValidator
    name="locTemplate"
    options={this.state.locTemplates}
    value={this.state.locTemplate}
    onChange={this.onChange}
    classes={classes}
    validators={['required']}
    errorMessages={['Location template is required']}
    label="Location Template"
/>
*/
export const AutoTextValidator = props => {
    return (
        <Autocomplete
            name={props.name}
            id={props.id || props.name}
            options={props.options}
            disabled={props.disabled}
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            value={props.value}
            onChange={(event, value) => {
                const defaultEvent = {
                    target: {
                        name: props.name || props.id,
                        value: value
                    }
                }
                return props.onChange(defaultEvent)
            }}
            className={[props.classes.autoComplete].join(' ')}
            autoHighlight
          renderOption={(props, option) => {
                                        return (
                                          <li {...props} key={option.value}>
                                            {option.label}
                                          </li>
                                        );
                                    }}  
            renderInput={(params) => (
                <TextValidator
                    {...params}
                    name={props.name}
                    required
                    label={props.label}
                    value={props.value}
                    errorMessages={props.errorMessages}
                    validators={props.validators}
                    className={[props.classes.textField].join(' ')}
                    fullWidth
                />)}
        />
    );
}
// export default GridAutoTextField;